




























































































































































































import _ from 'lodash';
import { Component, Vue, Prop } from 'vue-property-decorator';
import BalanceModal from '@/components/trading/trade-selloffer/modal/BalanceModal.vue';
import MessageModal from '@/components/app/MessageModal.vue';
import tradingService from '@/services/tradingService';
import { required, between, maxValue, minValue } from 'vuelidate/lib/validators';
import {
  Select,
  Button,
} from 'element-ui';
import { SellOffer } from '@/store/sellOffer/types';
import { Getter, Action } from 'vuex-class';
import { Asset } from '@/store/asset/types';
import { Wallet, UserWallet } from '@/store/wallet/types';
import { centsToEuro, currency } from '@/filters/currency';
import SellOfferDetails from './SellOfferDetails.vue';
import WalletDetails from './WalletDetails.vue';
import Fieldset from '@/components/common/Fieldset.vue';
import Stepper from '@/components/trading/Stepper.vue';
import { Steps } from '@/store/stepper/types';

@Component({
  name: 'trade-sell-offer-forms',
  components: {
    BalanceModal,
    SellOfferDetails,
    WalletDetails,
    Fieldset,
    MessageModal,
    Stepper,
  },
  filters: {
    centsToEuro,
    currency,
  },
})
export default class TradeSellOfferForms extends Vue {
  [ x: string ]: any;

  @Getter('appState/redirectUrl') redirectUrl?: string;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('wallet/userWallet') userWallet?: UserWallet;
  @Getter('sellOffer/createdTradeSellOffer') createdTradeSellOffer?: string;
  @Getter('stepper/steps') steps?: string[];
  @Getter('stepper/activeStep') activeStep?: number;

  @Action('appState/startLoader') startLoader;
  @Action('appState/stopLoader') stopLoader;
  @Action('sellOffer/createTradeSellOffer') createTradeSellOffer;
  @Action('stepper/setSteps') setSteps;
  @Action('stepper/nextStep') nextStep;
  @Action('stepper/backStep') backStep;
  @Action('stepper/setValidCurrentStep') setValidCurrentStep;

  @Prop({ default: null })
  asset?: Asset;

  @Prop({ required: true })
  sellOffer: SellOffer;

  @Prop({ required: true })
  wallet: Wallet;

  active: number = 0;
  createdSuccess: boolean = false;
  checkedOptions: Array<string> = [];
  message: any = null;

  tradeSellOfferForm = {
    pieces: null,
  }
  rules = {
    pieces: [
      {
        required: true,
        message: this.$t('tradeSellOffer.validationMessages.requiredPieces'),
        trigger: 'blur',
      },
      {
        type: 'number',
        min: 1,
        max: this.sellOffer.available,
        message: `${this.$t('tradeSellOffer.validationMessages.typeNumberPieces')} ${this.sellOffer.available}`,
        trigger: 'blur',
      },
    ],
  }
  balanceError = false;

  mounted() {
    const steps: Steps = [ {
      title: this.$t('tradeSellOffer.stepper', { context: 'step1' }),
      valid: null,
    },
    {
      title: this.$t('tradeSellOffer.stepper', { context: 'step2' }),
      valid: null,
    } ];
    this.setSteps(steps);
  }

  async next() {
    if (this.firstStep && !(await this.validateForm())) {
      this.setValidCurrentStep(false);

      return;
    }

    this.active++;
    this.setValidCurrentStep(true);
    this.scrollToTop();
  }

  cancel() {
    if(this.redirectUrl){
      return window.location.href = this.redirectUrl;
    }

    return this.$router.push('/');
  }

  public async validateForm(): Promise<boolean> {
    try {
      await this.$refs[ 'tradeSellOfferForm' ][ 'validate' ]();
      if (!this.assetIsBaader && this.totalAmount > this.wallet.amount) {
        this.balanceError = true;

        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  back() {
    this.active--;
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  get totalAmount() {
    return (this.tradeSellOfferForm.pieces * this.sellOffer.unit_price) || 0;
  }

  get firstStep() {
    return this.active === 0;
  }

  get secondStep() {
    return this.active === 1;
  }

  async onCreateSubmit() {
    this.startLoader();
    this.message = null;

    try {
      const tradeSellOffer = {
        pieces: this.tradeSellOfferForm.pieces,
      };
      const response = await this.createTradeSellOffer({ id: this.sellOffer.id, tradeSellOffer });

      this.onSubmitSuccess();
    } catch (error) {
      this.onSubmitError(_.get(error, 'response.status') || null);
    }
  }

  get successMessage() {
    return this.$t('tradeSellOffer.messages.info', { context: 'tradeSellOfferCreated' });
  }

  onSubmitSuccess() {
    this.createdSuccess = true;
    this.message = this.successMessage;
    this.next();
    this.stopLoader();
  }

  onSubmitError(status: number) {
    this.stopLoader();
    // show a generic error message
    this.message = this.$t('error.generic.title') + '.<br /><br />'+this.$t('error.generic.text', {
        link: `<a target='_blank' href='${this.$t('error.generic.linkPath')}'>
              ${this.$t('error.generic.linkTitle')}
              </a>` });

    this.createdSuccess = false;
    const customStatus = [ 404, 410, 417 ];
   
    if (customStatus.includes(status)) {
      this.message = this.$t('tradeSellOffer.messages.info', {
        context: `${status}`,
        link: `<a target='_blank' href='${this.$t('tradeSellOffer.messages.linkPath')}'>
              ${this.$t('tradeSellOffer.messages.linkTitle')}
              </a>` });
    }
  }

  get assetIsBaader() {
    return this.asset?.provider === 'baaderbank';
  }

  get hasAgreed() {
    return this.checkedOptions.length > 1;
  }

  get lockedAccount() {
    return !!this.userWallet.locked_at;
  }
  toggleBalanceModal() {
    this.balanceError = !this.balanceError;
  }
}
